import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { SimulationService } from '../../services/simulation.service';

@Injectable({ providedIn: 'root' })
export class SimulationGuard implements CanActivate {
    readonly _simulationService = inject(SimulationService);
    readonly _router = inject(Router);

    canActivate(): boolean {
        if (!this._simulationService.isSimulationMode) {
            this._router.navigate(['/no-permission']);
        }
        return this._simulationService.isSimulationMode;
    }
}